import React from "react";
import PropTypes from "prop-types";
import styles from "./index.css";
import Script from "react-inline-script";
import classnames from "classnames";
import withInitialTargeting from "./withInitialTargeting";
import commonConfig from "../../config/common";

const Advert = ({
  id,
  initialTargeting,
  adUnitPath,
  isDisplayed,
  className
}) => {
  const {
    adverts: { sizeMappings }
  } = commonConfig;

  const [
    {
      slotSizes: [mobileSlotSize]
    }
  ] = [...sizeMappings].reverse();
  const fallbackSlotSize = JSON.stringify(mobileSlotSize);

  const sizeMapping = JSON.stringify(
    sizeMappings.map(({ viewPortSize, slotSizes }) => [viewPortSize, slotSizes])
  );

  return (
    <React.Fragment>
      <div
        id={id}
        className={classnames(styles.advert, className, {
          [styles.hide]: !isDisplayed
        })}
      />
      <Script>
        {`
var googletag=googletag||{};googletag.cmd=googletag.cmd||[];
(function(){
  var g=googletag;
  g.cmd.push(function(){g.defineSlot("${adUnitPath}",${fallbackSlotSize},"${id}").defineSizeMapping(${sizeMapping}).addService(g.pubads())${initialTargeting};g.display("${id}");});
})();`}
      </Script>
    </React.Fragment>
  );
};

Advert.propTypes = {
  id: PropTypes.string.isRequired,
  initialTargeting: PropTypes.string,
  adUnitPath: PropTypes.string.isRequired,
  isDisplayed: PropTypes.bool.isRequired,
  className: PropTypes.string
};

export default withInitialTargeting(Advert);
